export enum DialogPositionClass {
    bottom = '',
    left = 'left-dialog',
    right = 'right-dialog'
}